import { CoreModule } from '@abp/ng.core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { ButtonModule } from 'primeng/button';
import { EditIconButtonComponent } from './components/edit-icon-button/edit-icon-button.component';
import { TooltipModule } from 'primeng/tooltip';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { LabelContentComponent } from './components/label-content/label-content.component';
import { BasicCardFooterComponent } from './components/basic-card-footer/basic-card-footer.component';
import { ChangePlaceModalComponent } from './components/change-place-modal/change-place-modal.component';
import { DialogModule } from 'primeng/dialog';
import { CareerCompetenciesBreadcrumbComponent } from './components/career-competencies-breadcrumb/career-competencies-breadcrumb.component';
import { CurrentPlaceDescriptionComponent } from './components/current-place-description/current-place-description.component';
import { CreateButtonComponent } from './components/create-button/create-button.component';
import { DeleteIconButtonComponent } from './components/delete-icon-button/delete-icon-button.component';
import { ActiveInactiveTagComponent } from './components/active-inactive-tag/active-inactive-tag.component';
import { TagModule } from 'primeng/tag';
import { FilterIconButtonComponent } from './components/filter-icon-button/filter-icon-button.component';
import { AnswerGroupStateDropdownComponent } from './components/answer-group-state-dropdown/answer-group-state-dropdown.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InformationSourceStateDropdownComponent } from './components/information-source-state-dropdown/information-source-state-dropdown.component';
import { SelectModule } from 'primeng/select';
import { UserAutocompleteComponent } from './components/user-autocomplete/user-autocomplete.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AreaSelectorComponent } from './components/area-selector/area-selector.component';
import { FluidModule } from 'primeng/fluid';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { QuestionStateDropdownComponent } from './components/question-state-dropdown/question-state-dropdown.component';
import { QuestionTypeDropdownComponent } from './components/question-type-dropdown/question-type-dropdown.component';
import { QuestionGroupStateDropdownComponent } from './components/question-group-state-dropdown/question-group-state-dropdown.component';
import { OperatorStateDropdownComponent } from './components/operator-state-dropdown/operator-state-dropdown.component';
import { EvaluateIconButtonComponent } from './components/evaluate-icon-button/evaluate-icon-button.component';
import { ShiftSelectorComponent } from './components/shift-selector/shift-selector.component';
import { PublishSaveButtonComponent } from './components/publish-save-button/publish-save-button.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { EvaluationTemplateStateDropdownComponent } from './components/evaluation-template-state-dropdown/evaluation-template-state-dropdown.component';
import { QuestionGroupDropdownComponent } from './components/question-group-dropdown/question-group-dropdown.component';
import { EvaluationTemplateHeaderComponent } from './components/evalation-template-header/evalation-template-header.component';
import { SliderModule } from 'primeng/slider';
import { AreaMultiSelectorComponent } from './components/area-multi-selector/area-multi-selector.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { AnswerGroupsDropdownComponent } from './components/answer-groups-dropdown/answer-groups-dropdown.component';
import { InformationSourcesDropdownComponent } from './components/information-sources-dropdown/information-sources-dropdown.component';
import { ConfigurationStateIconComponent } from './components/configuration-state-icon/configuration-state-icon.component';
import { ConfigureIconButtonComponent } from './components/configure-icon-button/configure-icon-button.component';
import {
  EvaluationStateDropdownComponent
} from './components/evaluation-state-dropdown/evaluation-state-dropdown.component';
import { EvaluationStateTagComponent } from './components/evaluation-state-tag/evaluation-state-tag.component';
import { ViewIconButtonComponent } from './components/view-icon-button/view-icon-button.component';
import { CopyIconButtonComponent } from './components/copy-icon-button/copy-icon-button.component';
import { EvaluationTemplateDropdownComponent } from './components/evaluation-template-dropdown/evaluation-template-dropdown.component';
import { EvaluationTypeColumnComponent } from './components/evaluation-type-column/evaluation-type-column.component';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { CreateUpdateQuestionComponent } from '../main/configuration/questions/create-update-question/create-update-question.component';
import { EvaluationsGridComponent } from './components/evaluations-grid/evaluations-grid.component';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    EditIconButtonComponent,
    BackButtonComponent,
    LabelContentComponent,
    BasicCardFooterComponent,
    ChangePlaceModalComponent,
    CareerCompetenciesBreadcrumbComponent,
    CurrentPlaceDescriptionComponent,
    CreateButtonComponent,
    DeleteIconButtonComponent,
    ActiveInactiveTagComponent,
    FilterIconButtonComponent,
    AnswerGroupStateDropdownComponent,
    InformationSourceStateDropdownComponent,
    AreaSelectorComponent,
    UserAutocompleteComponent,
    ToggleSwitchComponent,
    OperatorStateDropdownComponent,
    EvaluateIconButtonComponent,
    ShiftSelectorComponent,
    QuestionStateDropdownComponent,
    QuestionTypeDropdownComponent,
    QuestionGroupStateDropdownComponent,
    PublishSaveButtonComponent,
    EvaluationTemplateStateDropdownComponent,
    EvaluationTemplateHeaderComponent,
    QuestionGroupDropdownComponent,
    AreaMultiSelectorComponent,
    AnswerGroupsDropdownComponent,
    InformationSourcesDropdownComponent,
    ConfigurationStateIconComponent,
    ConfigureIconButtonComponent,
    EvaluationStateDropdownComponent,
    EvaluationStateTagComponent,
    ViewIconButtonComponent,
    CopyIconButtonComponent,
    EvaluationTemplateDropdownComponent,
    EvaluationTypeColumnComponent,
    CreateUpdateQuestionComponent,
    EvaluationsGridComponent,
  ],
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    FormsModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    TagModule,
    FloatLabelModule,
    SelectModule,
    AutoCompleteModule,
    FluidModule,
    ToggleSwitchModule,
    MultiSelectModule,
    InputTextModule,
    InputNumberModule,
    SliderModule,
    PaginatorModule,
    TableModule,
    DatePickerModule,
    DatePipe,
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    EditIconButtonComponent,
    BackButtonComponent,
    LabelContentComponent,
    BasicCardFooterComponent,
    ChangePlaceModalComponent,
    CareerCompetenciesBreadcrumbComponent,
    CreateButtonComponent,
    DeleteIconButtonComponent,
    ActiveInactiveTagComponent,
    FilterIconButtonComponent,
    AnswerGroupStateDropdownComponent,
    InformationSourceStateDropdownComponent,
    AreaSelectorComponent,
    UserAutocompleteComponent,
    TagModule,
    SelectModule,
    FloatLabelModule,
    FluidModule,
    ToggleSwitchComponent,
    ToggleSwitchModule,
    ButtonModule,
    QuestionGroupDropdownComponent,
    QuestionStateDropdownComponent,
    QuestionTypeDropdownComponent,
    QuestionGroupStateDropdownComponent,
    OperatorStateDropdownComponent,
    EvaluateIconButtonComponent,
    ShiftSelectorComponent,
    PublishSaveButtonComponent,
    InputTextModule,
    InputNumberModule,
    EvaluationTemplateStateDropdownComponent,
    EvaluationTemplateHeaderComponent,
    QuestionGroupDropdownComponent,
    SliderModule,
    TooltipModule,
    ShiftSelectorComponent,
    AreaMultiSelectorComponent,
    DialogModule,
    PaginatorModule,
    TableModule,
    AnswerGroupsDropdownComponent,
    InformationSourcesDropdownComponent,
    MultiSelectModule,
    ConfigurationStateIconComponent,
    ConfigureIconButtonComponent,
    EvaluationStateDropdownComponent,
    EvaluationStateTagComponent,
    ViewIconButtonComponent,
    CopyIconButtonComponent,
    EvaluationTemplateDropdownComponent,
    EvaluationTypeColumnComponent,
    CreateUpdateQuestionComponent,
    DatePickerModule,
    EvaluationsGridComponent,
    DatePipe,
  ],
  providers: [DatePipe]
})
export class SharedModule {}
